import { useStaticQuery, graphql } from 'gatsby'

const useWhyUs = () => {
  const data = useStaticQuery(graphql`
    {
      wpPage(title: { eq: "Home" }) {
        flexPage {
          pageBuilder {
            ... on WpPage_Flexpage_PageBuilder_WhyUs {
              headerText
              mainText
              reasons {
                text
                icon
              }
              sectionBackground {
                ...LocalImageFrag_bg
              }
              sectionTitle
              bottomSection {
                since
                main
                heading
                certifications {
                  image {
                    ...LocalImageFrag
                  }
                }
                background {
                  ...LocalImageFrag_bg
                }
              }
            }
          }
        }
      }
    }
  `)
  return data.wpPage.flexPage
}

export default useWhyUs
